import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { CLINIC } from "../mock";
import Logo from "./Logo";

const LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/hair-clinic", label: "Hair Clinic" },
  { to: "/results", label: "Results" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled ? "bg-charcoal/95 backdrop-blur-md py-3 shadow-lg" : "bg-gradient-to-b from-charcoal/70 to-transparent py-5"
      }`}
    >
      <div className="max-w-[1360px] mx-auto px-6 flex items-center justify-between">
        <Logo size="md" />

        <nav className="hidden xl:flex items-center gap-8">
          {LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              className={`nav-link text-cream/90 hover:text-gold ${
                location.pathname === l.to ? "active text-gold" : ""
              }`}
            >
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="hidden xl:flex items-center gap-5">
          <a
            href={`tel:${CLINIC.phone}`}
            className="flex items-center gap-2 text-cream/80 hover:text-gold transition-colors"
          >
            <Phone size={15} strokeWidth={1.5} />
            <span className="text-xs tracking-widest">{CLINIC.phone}</span>
          </a>
          <Link to="/booking" className="btn-gold">
            Book Now
          </Link>
        </div>

        <button
          className="xl:hidden text-cream"
          onClick={() => setOpen((o) => !o)}
          aria-label="Menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {/* Mobile menu */}
      <div
        className={`xl:hidden overflow-hidden transition-all duration-500 bg-charcoal ${
          open ? "max-h-[560px] py-6" : "max-h-0"
        }`}
      >
        <nav className="flex flex-col items-center gap-6 px-6">
          {LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              className={`nav-link text-cream/90 ${
                location.pathname === l.to ? "text-gold" : ""
              }`}
            >
              {l.label}
            </Link>
          ))}
          <Link to="/booking" className="btn-gold w-full text-center">
            Book Now
          </Link>
        </nav>
      </div>
    </header>
  );
}
